import type { ReactNode } from 'react'

import { Card } from '@/components/ui/card'
import { cn } from '@/lib/utils'

export interface StatListItem {
    label: string
    value: ReactNode
    /** Nhấn mạnh chỉ số cần chú ý (vd nợ quá hạn > 0). */
    valueClassName?: string
}

interface StatListCardProps {
    title?: string
    items: StatListItem[]
    className?: string
}

/**
 * Khối chỉ số dạng danh sách: mỗi chỉ số một dòng, nhãn trái — số phải.
 *
 * Cùng bố cục với các block của manager dashboard: số tiền hàng tỷ cần trọn
 * chiều ngang, nhét vào ô grid 2 cột trên mobile là vỡ dòng ("5.446.603.44 đ"
 * xuống hàng). Dùng cho các khối tổng hợp ở `/reports` dưới breakpoint `sm`.
 */
export function StatListCard({ title, items, className }: StatListCardProps) {
    return (
        <Card className={cn('p-4', className)}>
            {title && (
                <h2 className="mb-1 text-sm font-medium text-muted-foreground">
                    {title}
                </h2>
            )}
            <dl className="divide-y">
                {items.map((item) => (
                    <div
                        key={item.label}
                        className="flex items-baseline justify-between gap-3 py-2"
                    >
                        <dt className="text-sm text-muted-foreground">
                            {item.label}
                        </dt>
                        <dd
                            className={cn(
                                'whitespace-nowrap text-right text-base font-bold tabular-nums',
                                item.valueClassName,
                            )}
                        >
                            {item.value}
                        </dd>
                    </div>
                ))}
            </dl>
        </Card>
    )
}
